import {
    isValidEmailAllowlistEntry,
    normalizeEmailAllowlistEntry,
} from './emailAllowlist';

const PROVIDER_DOMAINS = {
    gmail: new Set(['gmail.com', 'googlemail.com']),
    microsoft_graph: new Set([
        'outlook.com',
        'hotmail.com',
        'live.com',
        'office365.com',
    ]),
};

const IMAP_PRESETS = {
    'gmail.com': { imap_host: 'imap.gmail.com', imap_port: 993, smtp_host: 'smtp.gmail.com', smtp_port: 465 },
    'googlemail.com': { imap_host: 'imap.gmail.com', imap_port: 993, smtp_host: 'smtp.gmail.com', smtp_port: 465 },
    'yahoo.com': { imap_host: 'imap.mail.yahoo.com', imap_port: 993, smtp_host: 'smtp.mail.yahoo.com', smtp_port: 465 },
    'fastmail.com': { imap_host: 'imap.fastmail.com', imap_port: 993, smtp_host: 'smtp.fastmail.com', smtp_port: 465 },
    'zoho.com': { imap_host: 'imap.zoho.com', imap_port: 993, smtp_host: 'smtp.zoho.com', smtp_port: 465 },
};

export function suggestEmailProvider(email) {
    const domain = String(email || '').trim().toLowerCase().split('@')[1] || '';
    if (!domain) return null;
    for (const [providerType, domains] of Object.entries(PROVIDER_DOMAINS)) {
        if (domains.has(domain)) return { provider_type: providerType, domain };
    }
    return {
        provider_type: 'imap_smtp',
        domain,
        ...(IMAP_PRESETS[domain] || {}),
    };
}

export function normalizeSenderBlocklist(values) {
    const list = Array.isArray(values) ? values : String(values || '').split(/[\n,]+/);
    return [...new Set(list
        .map(normalizeEmailAllowlistEntry)
        .filter((entry) => entry && isValidEmailAllowlistEntry(entry)))];
}

export function mailboxStatusLabel(status, isActive = false) {
    if (status === 'connected') return 'Connected';
    if (status === 'paused' || (!status && !isActive)) return 'Paused';
    return 'Needs attention';
}
